<div class="login-signup-box popout-register">
    <div class="modal-body">
        <form [formGroup]="registrationForm">
            <h3 id="signup-modal-title" class="sr-only">Register New Account</h3>
            <p><strong>New user register here</strong></p>
            <div class="form-group">
                <div class="text-box-wrap">
                    <label for="signupName" class="sr-only">Full Name</label>
                    <input type="text" id="signupName" formControlName="name" class="form-control" placeholder="Name" maxlength="50"
                        autocomplete="name" aria-required="true"
                        [ngClass]="{'is-invalid': formErrors.name}"
                        [attr.aria-invalid]="fc.name.invalid && fc.name.touched"
                        [attr.aria-describedby]="fc.name.errors ? 'signupNameError' : null">
                    <div *ngIf="fc.name.errors" id="signupNameError" class="invalid-feedback" role="alert">
                        <div *ngIf="fc.name.errors.required">
                            Please enter your Name
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="text-box-wrap">
                    <label for="signupEmail" class="sr-only">Email Address</label>
                    <input type="email" id="signupEmail" formControlName="email" class="form-control" maxlength="50" (keyup)="trimEmail()"
                        placeholder="Email Address" autocomplete="email" aria-required="true"
                        [ngClass]="{'is-invalid': formErrors.email}"
                        [attr.aria-invalid]="fc.email.invalid && fc.email.touched"
                        [attr.aria-describedby]="fc.email.errors ? 'signupEmailError' : null">
                    <div *ngIf="fc.email.errors" id="signupEmailError" class="invalid-feedback" role="alert">
                        <div *ngIf="fc.email.errors">
                            Please enter your Email
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="text-box-wrap">
                    <label for="signupMobile" class="sr-only">Mobile Number</label>
                    <input usNumberFormat type="tel" id="signupMobile" formControlName="mobile" class="form-control" maxlength="14"
                        placeholder="Mobile Number" autocomplete="tel" aria-required="true"
                        [ngClass]="{'is-invalid': formErrors.mobile}"
                        [attr.aria-invalid]="fc.mobile.invalid && fc.mobile.touched"
                        [attr.aria-describedby]="fc.mobile.errors ? 'signupMobileError' : null">
                    <div *ngIf="fc.mobile.errors" id="signupMobileError" class="invalid-feedback" role="alert">
                        <div *ngIf="fc.mobile.errors.required">
                            Please enter your Mobile
                        </div>
                        <div *ngIf="fc.mobile.errors.minlength || fc.mobile.errors.maxlength || fc.mobile.errors.pattern">
                            Please enter valid mobile no of 10 digits
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="text-box-wrap">
                    <label for="signupPassword" class="sr-only">Password</label>
                    <input type="password" id="signupPassword" formControlName="password" class="form-control" placeholder="Password"
                        maxlength="50" autocomplete="new-password" aria-required="true"
                        [ngClass]="{'is-invalid': formErrors.password}"
                        [attr.aria-invalid]="fc.password.invalid && fc.password.touched"
                        [attr.aria-describedby]="fc.password.errors ? 'signupPasswordError' : null">
                    <div *ngIf="fc.password.errors" id="signupPasswordError" class="invalid-feedback" role="alert">
                        <div *ngIf="fc.password.errors.required">
                            Please enter Password
                        </div>
                    </div>
                </div>

            </div>
            <div class="form-group">
                <div class="text-box-wrap">
                    <label for="signupConfirmPassword" class="sr-only">Confirm Password</label>
                    <input type="password" id="signupConfirmPassword" formControlName="confirmPassword" class="form-control" maxlength="50"
                        placeholder="Confirm Password" autocomplete="new-password" aria-required="true"
                        [ngClass]="{'is-invalid': formErrors.confirmPassword}"
                        [attr.aria-invalid]="fc.confirmPassword.invalid && fc.confirmPassword.touched"
                        [attr.aria-describedby]="fc.confirmPassword.errors ? 'signupConfirmPasswordError' : null">
                    <div *ngIf="fc.confirmPassword.errors" id="signupConfirmPasswordError" class="invalid-feedback" role="alert">
                        <div *ngIf="fc.confirmPassword.errors.required">
                            Please enter confirm Password
                        </div>
                        <div *ngIf="fc.confirmPassword.errors.mustMatch">
                            Password & Confirm Password are different
                        </div>
                    </div>
                </div>

            </div>
            <div class="form-group">
                <button type="button" [disabled]="!registrationForm.valid" (click)="signUp()" [ngStyle]="clientConfig.style.bg"
                    class="app-btn btn btn-danger btn-block">Sign Up</button>
            </div>

            <p style="font-size:12px;" class="text-black"> By Signing up you agree to our <a class="text-black"
                    target="_blank" rel="noopener noreferrer" [routerLink]="['/home/tc']">Terms &
                    Condition<span class="sr-only"> (opens in a new tab)</span></a></p>
        </form>
    </div>
</div>